// Fonction utilitaire pour récupérer le token d'authentification
// Compatible avec les deux modes : standard et bastion

export const getAuthToken = () => {
  // Essayer d'abord le token bastion
  let token = localStorage.getItem('bastionToken');
  
  // Si pas de token bastion, essayer le token standard
  if (!token) {
    token = localStorage.getItem('token');
  }
  
  return token;
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : ''
  };
};

export const fetchWithAuth = async (url, options = {}) => {
  const headers = {
    ...getAuthHeaders(),
    ...options.headers
  };
  
  return fetch(url, {
    ...options,
    headers
  });
};